'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var cid = require('multiformats/cid');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

function createPut(_ref) {
  var repo = _ref.repo,
      codecs = _ref.codecs,
      hashers = _ref.hashers,
      preload = _ref.preload;

  function put(_x) {
    return _put.apply(this, arguments);
  }

  function _put() {
    _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dagNode) {
      var options,
          release,
          codecName,
          cidVersion,
          codec,
          hasher,
          buf,
          hash,
          cid$1,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

              if (!options.pin) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return repo.gcLock.readLock();

            case 4:
              _context.t0 = _context.sent;
              _context.next = 8;
              break;

            case 7:
              _context.t0 = null;

            case 8:
              release = _context.t0;
              _context.prev = 9;
              codecName = options.format || 'dag-cbor';
              cidVersion = options.version != null ? options.version : codecName === 'dag-pb' ? 0 : 1;
              _context.next = 14;
              return codecs.getCodec(codecName);

            case 14:
              codec = _context.sent;

              if (codec) {
                _context.next = 17;
                break;
              }

              throw new Error("Unknown codec ".concat(options.format, ", please configure additional BlockCodecs for this IPFS instance"));

            case 17:
              _context.next = 19;
              return hashers.getHasher(options.hashAlg || 'sha2-256');

            case 19:
              hasher = _context.sent;

              if (hasher) {
                _context.next = 22;
                break;
              }

              throw new Error("Unknown hash algorithm ".concat(options.hashAlg, ", please configure additional MultihashHashers for this IPFS instance"));

            case 22:
              buf = codec.encode(dagNode);
              _context.next = 25;
              return hasher.digest(buf);

            case 25:
              hash = _context.sent;
              cid$1 = cid.CID.create(cidVersion, codec.code, hash);
              _context.next = 29;
              return repo.blocks.put(cid$1, buf, {
                signal: options.signal
              });

            case 29:
              if (!options.pin) {
                _context.next = 32;
                break;
              }

              _context.next = 32;
              return repo.pins.pinRecursively(cid$1);

            case 32:
              if (options.preload !== false) {
                preload(cid$1);
              }

              return _context.abrupt("return", cid$1);

            case 34:
              _context.prev = 34;

              if (release) {
                release();
              }

              return _context.finish(34);

            case 37:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9,, 34, 37]]);
    }));
    return _put.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(put);
}

exports.createPut = createPut;